import * as S from './styles'

export const AppearFromRight = ({
  children
}: {
  children: React.ReactNode
}) => {
  return <S.Container>{children}</S.Container>
}
